import React from "react";
import checkIcon from "../../assets/check.svg";
import logoBlack from "../../assets/logo-black.svg";
import { LogoutButton } from "./LogoutButton";

/** Formata "2026-07-28" como "28/07/2026" sem sofrer com fuso horário. */
function formatDate(isoDate: string): string {
  const [year, month, day] = isoDate.split("-");
  if (!year || !month || !day) return isoDate;
  return `${day}/${month}/${year}`;
}

interface ConfirmationProps {
  emRevisao: boolean;
  liberacaoPrevista: string | null;
}

export function Confirmation({ emRevisao, liberacaoPrevista }: ConfirmationProps) {
  return (
    <div className="results results--confirmation">
      <div className="results__card results__card--confirmation">
        <img
          src={checkIcon}
          alt=""
          className="results__check"
          aria-hidden="true"
        />

        <h1 className="results__title results__title--confirmation">
          {emRevisao
            ? "Participação em análise"
            : "Sua participação foi confirmada!"}
        </h1>

        {emRevisao ? (
          <p className="results__subtitle">
            Nossa equipe está verificando a sua participação.
            <br />
            Em breve seus números estarão disponíveis por aqui.
          </p>
        ) : liberacaoPrevista ? (
          <p className="results__subtitle">
            Seus números serão liberados em
            <br />
            <strong>{formatDate(liberacaoPrevista)}</strong>.
          </p>
        ) : (
          <p className="results__subtitle">
            Seus números da sorte serão disponibilizados
            <br />
            em até 7 dias após a compra.
          </p>
        )}

        <img
          src={logoBlack}
          alt="De Carona com Toro"
          className="results__logo"
        />

        <LogoutButton />
      </div>
    </div>
  );
}
